export default [
	'1.jpg',
];

// list of photo names for about page